"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const config_1 = require("config");
const merchant_portal_components_1 = require("merchant-portal-components");
const utils_1 = require("utils");
const TDCellStatus = ({ value, row, handleClick, }) => {
    const mappedStatus = config_1.TRANSACTION_STATUS_MAP[value];
    if (!mappedStatus) {
        return (0, jsx_runtime_1.jsx)("div", { children: (0, utils_1.formatUpperCase)(value) });
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "mar-right-4", children: (0, jsx_runtime_1.jsx)(merchant_portal_components_1.TransactionStatusPillButton, { status: mappedStatus, onClick: () => handleClick(row.original) }) }));
};
exports.default = TDCellStatus;
